module.exports = __webpack_public_path__ + "static/media/features-split-image-03.c8089942.png";